module.exports = __webpack_public_path__ + "5421857205898e7cebd9ac16ea94e44a.png";